export const emptyDecorator = (v) => v;
